import React, { useState } from "react";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import JarvisCard from "components/JarvisCard";
import Image from "components/common/Image";
import { formatHelper } from "helper/format";
import Box from "components/common/Box";
import { useHistory } from "react-router-dom";

const MobileRMSDashboardStats = (props) => {
  const { portfolioStats, rmsCallStats } = props;
  const [showCashCTA, setShowCashCTA] = useState(false);
  const history = useHistory();

  const {
    totalAUM,
    totalStocks,
    portfolioAUM,
    portfolioStockQuantity,
    totalCash,
    suggestProduct,
  } = portfolioStats;
  const {
    totalRMSCalls,
    totalDownfallSaved,
    totalDownfallSavedPercentage,
    totalOpportunityLost,
    RMScalls,
    downfallSaved,
    opportunityLost,
    cashReleased = 0,
    // totalOpportunityLostPercentage,
  } = rmsCallStats;

  const handleRidirect = () => {
    const text = suggestProduct.toLowerCase();

    // 2. redirect logic
    if (text.includes("portfolio")) {
      history.push("/jarvis-portfolio/dashboard");
    } else if (text.toLowerCase().includes("one stock")) {
      history.push("/jarvis-onestock/dashboard");
    }
  };

  const handlerShowCash = () => {
    if (suggestProduct?.length > 0) {
      setShowCashCTA(!showCashCTA);
    }
  };

  return (
    <>
      <JarvisCard sx={{ border: "1px solid #EEF0F2", mb: "12px", p: 2 }}>
        <Stack spacing={2}>
          {/* ------- TOP VALUES (LEFT + RIGHT) ------- */}
          <Stack direction="row" justifyContent="space-between">
            {/* AUM under monitor */}
            <Stack>
              <Text sx={{ fontWeight: 700, fontSize: "20px", color: "#000" }}>
                {isNaN(portfolioAUM ? portfolioAUM : totalAUM)
                  ? "-"
                  : formatHelper.currency(
                      Math.abs(portfolioAUM ? portfolioAUM : totalAUM)
                    )}
              </Text>
              <Text variant="caption1" sx={{ color: "#808591" }}>
                AUM under monitor
              </Text>
            </Stack>

            {/* Stocks under monitor */}
            <Stack alignItems="flex-end">
              <Text sx={{ fontWeight: 700, fontSize: "20px", color: "#000" }}>
                {totalStocks ? totalStocks : 0}
              </Text>
              <Text variant="caption1" sx={{ color: "#808591" }}>
                Stocks under monitor
              </Text>
            </Stack>
          </Stack>

          {/* Divider */}
          <Text sx={{ borderBottom: "1px solid #F0F0F0", my: 1 }}></Text>

          {/* ------- MIDDLE VALUES: Downfall Saved + Opportunity Lost ------- */}
          <Stack direction="row" justifyContent="space-between">
            {/* Average downfall saved */}
            <Stack sx={{ minWidth: "50%" }}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Image
                  src="/images/product-info/mobile-average-downfall.png"
                  width={12}
                />
                <Text sx={{ color: "#45AC70", fontWeight: 600 }}>
                  {isNaN(downfallSaved)
                    ? "-"
                    : formatHelper.currency(Math.abs(downfallSaved))}
                </Text>
                {/** percentage if you want like screenshot "18%" */}
                {totalDownfallSavedPercentage && (
                  <Text sx={{ color: "#45AC70", fontWeight: 600 }}>
                    {totalDownfallSavedPercentage}%
                  </Text>
                )}
              </Stack>

              <Text variant="caption1" sx={{ color: "#808591" }}>
                Average downfall Saved
              </Text>
            </Stack>

            {/* Opportunity Lost */}
            <Stack sx={{ minWidth: "50%" }} alignItems="flex-end">
              <Stack direction="row" alignItems="center">
                <Text sx={{ color: "#E0953D", fontWeight: 600 }}>
                  {isNaN(opportunityLost)
                    ? "-"
                    : formatHelper.currency(Math.abs(opportunityLost))}
                </Text>
              </Stack>

              <Text variant="caption1" sx={{ color: "#808591" }}>
                Opportunity Lost
              </Text>
            </Stack>
          </Stack>
        </Stack>

        {/* -------- Bottom Card: Cash Released -------- */}
        <JarvisCard
          sx={{
            border: "1px solid #EEF0F2",
            height: "90px",
            marginTop: "10px",
          }}
          onClick={() => setShowCashCTA(!showCashCTA)}
        >
          <Stack>
            <Text sx={{ fontWeight: 700, fontSize: "20px", color: "#000" }}>
              {isNaN(totalCash)
                ? "-"
                : formatHelper.currency(Math.abs(totalCash))}
            </Text>
            <Text variant="caption1" sx={{ color: "#808591" }}>
              Cash Released
            </Text>
          </Stack>
        </JarvisCard>
        {showCashCTA && (
          <Box
            sx={{
              p: 1.5,
              background: "linear-gradient(90deg, #00D1FF, #406BFF)",
              borderBottomLeftRadius: "10px",
              borderBottomRightRadius: "10px",
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Text color="#fff" sx={{ fontSize: "10px" }}>
                ✨ {suggestProduct}
              </Text>
              <Text
                color="#fff"
                sx={{
                  textDecoration: "underline",
                  fontWeight: 300,
                  fontSize: 14,
                  cursor: "pointer",
                }}
                onClick={() => handleRidirect()}
              >
                Invest Now
              </Text>
            </Stack>
          </Box>
        )}
      </JarvisCard>

      {/* <JarvisCard sx={{ border: "1px solid #EEF0F2", marginBottom: "20px" }}>
        <Stack direction="row">
          <Stack sx={{ minWidth: "60%" }}>
            <Stack>
              <Text sx={{ fontWeight: "700", color: "#222B3E" }}>
                {totalStocks}
              </Text>
              <Text variant="caption1" sx={{ color: "#808591" }}>
                Stocks under monitor
              </Text>
            </Stack>
          </Stack>
          <Stack sx={{ minWidth: "40%" }}>
            <Stack>
              <Text sx={{ fontWeight: "700", color: "#222B3E" }}>
                {totalRMSCalls}
              </Text>
              <Text variant="caption1" sx={{ color: "#808591" }}>
                Total sell calls
              </Text>
            </Stack>
          </Stack>
        </Stack>
      </JarvisCard> */}
    </>
  );
};

export default MobileRMSDashboardStats;
